import { useState } from "react";
import { FIXED_TAGS, tagClasses, tagSlug } from "@/lib/tags";
import { Input } from "@/components/ui/input";
import { X, Plus } from "lucide-react";

// Multi-select tag picker: fixed presets + custom tags.
export default function TagPicker({ value = [], onChange, testid = "tag-picker" }) {
  const [custom, setCustom] = useState("");
  const toggle = (t) => onChange(value.includes(t) ? value.filter((x) => x !== t) : [...value, t]);
  const addCustom = () => {
    const t = custom.trim();
    if (t && !value.includes(t)) onChange([...value, t]);
    setCustom("");
  };
  const extras = value.filter((t) => !FIXED_TAGS.includes(t));

  return (
    <div data-testid={testid}>
      <div className="flex flex-wrap gap-1.5">
        {FIXED_TAGS.map((t) => (
          <button type="button" key={t} onClick={() => toggle(t)}
            className={`text-[11px] px-2.5 py-1 rounded-full border transition-colors ${value.includes(t) ? tagClasses(t) : "bg-white text-slate-400 border-slate-200 hover:border-slate-300"}`}
            data-testid={`tag-opt-${tagSlug(t)}`}>{t}</button>
        ))}
        {extras.map((t) => (
          <span key={t} className={`text-[11px] px-2.5 py-1 rounded-full border inline-flex items-center gap-1 ${tagClasses(t)}`} data-testid={`tag-chip-${tagSlug(t)}`}>
            {t}<button type="button" onClick={() => toggle(t)}><X size={11} /></button>
          </span>
        ))}
      </div>
      <div className="flex gap-1.5 mt-2">
        <Input value={custom} onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addCustom(); } }}
          placeholder="Custom tag…" className="h-8 text-xs" data-testid="tag-custom-input" />
        <button type="button" onClick={addCustom} className="px-2 rounded-md border border-slate-200 text-slate-500 hover:text-[#2495D3]" data-testid="tag-custom-add"><Plus size={14} /></button>
      </div>
    </div>
  );
}
